<template>
  <div>
    <div
      v-if="!loading"
      class="app"
    >
      <app-header />
      <div
        id="app"
        :class="{ 'sidebar-minimized': !showSidebar}"
        class="app-body sidebar-fixed"
      >
        <app-sidebar :nav-items="navigation" />
        <main class="main">
          <div class="container-fluid">
            <router-view />
          </div>
        </main>
      </div>
    </div>
    <div
      v-else
      class="global-loader"
    >
      <div /><div />
    </div>
  </div>
</template>

<script>
import { AppHeader, AppSidebar } from '../components';
import SidebarStateStorage from '../storage/SidebarStateStorage';
import NavigationMixin from '../mixins/NavigationMixin';
import VuexUpdateMixins from '../mixins/VuexUpdateMixins';

export default {
  name: 'Full',
  components: {
    AppSidebar,
    AppHeader,
  },
  mixins: [
    NavigationMixin,
    VuexUpdateMixins,
  ],
  data() {
    return {
      showSidebar: SidebarStateStorage.get(),
      loading: true,
    };
  },
  computed: {
    name() {
      return this.$route.name;
    },
  },
  created() {
    setTimeout(() => {
      this.loading = false;
    }, 3000);

    this.updateUserVuexStore();
  },
};
</script>

<style lang="scss" scoped>
  @import "~bootstrap-vars";

  .global-loader {
    display: inline-block;
    position: fixed;
    width: 128px;
    height: 128px;
    top: calc(50% - 64px);
    left: calc(50% - 64px);

    div {
      position: absolute;
      border: 4px solid $gray-600;
      opacity: 1;
      border-radius: 50%;
      animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;

      &:nth-child(2) {
        animation-delay: -0.5s;
      }
    }
  }

  @keyframes lds-ripple {
    0% {
      top: 56px;
      left: 56px;
      width: 0;
      height: 0;
      opacity: 1;
    }
    100% {
      top: -1px;
      left: -1px;
      width: 116px;
      height: 116px;
      opacity: 0;
    }
  }

</style>
